import React from "react";
import "./KnowledgeHero.css";

import { Link } from "react-router-dom";
import Navbar from "../../Header/Navbar";

const RoutineHero = () => {
  return (
    <>
      <Navbar />

      {/* HERO SECTION */}
      <section className="hk-mini-hero">
        <div className="hk-mini-container">
          {/* Main Title */}
          <h1 className="hk-mini-title">
           Routine Financial Process Outsourcing
          </h1>

          {/* Breadcrumb */}
          <p className="hk-mini-breadcrumb">
            <Link to="/" className="hk-mini-link">Home</Link>
            <span>-</span>
            <Link to="/services" className="hk-mini-link">Our Services</Link>
            <span>-</span>
            <Link to="/routine-fpo" className="hk-mini-link">
              Routine Financial Process Outsourcing
            </Link>
          </p>
        </div>
      </section>

      {/* TAG BELOW HERO */}
     
    </>
  );
};

export default RoutineHero;
